export default __webpack_public_path__ + "static/logo-3e5a66723a430d84b8d99eaaa1bde075.png";